/**
 * Le parole dell’albero delle sezioni (compositore di pagina e regioni dei
 * layout). Inserite nello stesso albero di dizionario degli altri file, così
 * `dict.test.ts` controlla italiano e inglese insieme.
 */
import type { DictNode } from './dict.js'

export const sectionTreeIt: DictNode = {
  sectionTree: {
    label: 'Albero delle sezioni',
    help: 'Frecce per muoverti, Invio per aprire le proprietà, Alt + frecce per spostare, Canc per rimuovere, M per «Sposta in…».',
    empty: 'Nessuna sezione.',
    expand: 'Espandi {{title}}',
    collapse: 'Comprimi {{title}}',
    expandAll: 'Espandi tutto',
    collapseAll: 'Comprimi tutto',
    children: '{{count}} figli',
    child: '1 figlio',
    fromQuery: 'Da query',
    fromQueryHelp: 'I contenuti arrivano da una ricerca nel CMS, non sono scritti a mano.',
    style: 'Stile: {{value}}',
    warningEmpty: 'Sezione vuota',
    warningMissing: 'Manca: {{props}}',
    warningsTitle: '{{count}} sezioni da completare',
    warningsOk: 'Tutte le sezioni hanno un contenuto.',
    goToWarning: 'Vai a «{{title}}»',
    undo: 'Annulla ultima mossa',
    undone: 'Mossa annullata',
    add: 'Aggiungi sezione',
    duplicate: 'Duplica',
    remove: 'Rimuovi',
    moveTo: 'Sposta in…',
    moveUp: 'Sposta su',
    moveDown: 'Sposta giù',
    indent: 'Annida nella sezione sopra',
    outdent: 'Porta fuori dal genitore',
    dragHandle: 'Trascina per spostare «{{title}}»',
    dropBefore: 'Prima',
    dropInside: 'Dentro',
    dropAfter: 'Dopo',
    positionLabel: 'Sezione {{position}} di {{total}}',
    announceMoved: '«{{title}}» spostata: posizione {{position}} di {{total}}{{where}}',
    announceInside: ', dentro «{{parent}}»',
    announceTop: ', al primo livello',
    announceRemoved: '«{{title}}» rimossa',
    announceDuplicated: '«{{title}}» duplicata',
    announceAdded: '«{{title}}» aggiunta',
    cannotNest: 'Una sezione non può stare dentro se stessa.',
    moveDialog: {
      title: 'Sposta «{{title}}»',
      parent: 'Dentro a',
      topLevel: 'Primo livello',
      position: 'Posizione',
      positionN: '{{n}}',
      positionLast: '{{n}} (in fondo)',
      confirm: 'Sposta',
      help: 'Le sezioni che contiene la seguono. Non puoi scegliere la sezione stessa né una sua sottosezione.',
    },
    addDialog: {
      title: 'Aggiungi una sezione',
      search: 'Cerca nel catalogo',
      searchHelp: 'Nome o descrizione, per esempio «prezzi» o «domande».',
      noResults: 'Nessuna sezione corrisponde a «{{query}}».',
      where: 'Dove',
      end: 'In fondo, al primo livello',
      after: 'Dopo «{{title}}»',
      inside: 'Dentro «{{title}}»',
      choose: 'Aggiungi {{name}}',
    },
  },
}

export const sectionTreeEn: DictNode = {
  sectionTree: {
    label: 'Section tree',
    help: 'Arrow keys to move around, Enter to open the properties, Alt + arrows to reorder, Delete to remove, M for “Move to…”.',
    empty: 'No sections.',
    expand: 'Expand {{title}}',
    collapse: 'Collapse {{title}}',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
    children: '{{count}} children',
    child: '1 child',
    fromQuery: 'From query',
    fromQueryHelp: 'The contents come from a search in the CMS, they are not typed by hand.',
    style: 'Style: {{value}}',
    warningEmpty: 'Empty section',
    warningMissing: 'Missing: {{props}}',
    warningsTitle: '{{count}} sections to complete',
    warningsOk: 'Every section has content.',
    goToWarning: 'Go to “{{title}}”',
    undo: 'Undo last move',
    undone: 'Move undone',
    add: 'Add section',
    duplicate: 'Duplicate',
    remove: 'Remove',
    moveTo: 'Move to…',
    moveUp: 'Move up',
    moveDown: 'Move down',
    indent: 'Nest under the section above',
    outdent: 'Move out of the parent',
    dragHandle: 'Drag to move “{{title}}”',
    dropBefore: 'Before',
    dropInside: 'Inside',
    dropAfter: 'After',
    positionLabel: 'Section {{position}} of {{total}}',
    announceMoved: '“{{title}}” moved: position {{position}} of {{total}}{{where}}',
    announceInside: ', inside “{{parent}}”',
    announceTop: ', at the top level',
    announceRemoved: '“{{title}}” removed',
    announceDuplicated: '“{{title}}” duplicated',
    announceAdded: '“{{title}}” added',
    cannotNest: 'A section cannot go inside itself.',
    moveDialog: {
      title: 'Move “{{title}}”',
      parent: 'Inside',
      topLevel: 'Top level',
      position: 'Position',
      positionN: '{{n}}',
      positionLast: '{{n}} (at the end)',
      confirm: 'Move',
      help: 'Its own sections go with it. You cannot pick the section itself or one of its subsections.',
    },
    addDialog: {
      title: 'Add a section',
      search: 'Search the catalogue',
      searchHelp: 'Name or description, for example “pricing” or “questions”.',
      noResults: 'No section matches “{{query}}”.',
      where: 'Where',
      end: 'At the end, top level',
      after: 'After “{{title}}”',
      inside: 'Inside “{{title}}”',
      choose: 'Add {{name}}',
    },
  },
}
